import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchYoyAdsProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchYoyAds = (filters: FetchYoyAdsProps) => void;

const fetchYoyAds = ({
  clusters = [],
  partners = [],
  origami,
}: FetchYoyAdsProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("yoy_ads", dispatch, params);
};

export default fetchYoyAds;
